import React, { useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Container, Row, Col } from 'reactstrap'
import ReactGA from 'react-ga'
import { userActions } from '../../redux/actions'
import { Loading } from "../Utils/Loading"
import { AppPagePopup } from "."

export const ConsentPage = () => {
  const dispatch = useDispatch()
  const { isLoading, consentRequired, error } = useSelector(state => state.users)
  const [acceptedTos, setAcceptedTos] = React.useState(false)
  const [acceptedDataShare, setAcceptedDataShare] = React.useState(false)

  useEffect(() => {
    setAcceptedTos(!consentRequired.includes('TOS_PRIVACY'))
    setAcceptedDataShare(!consentRequired.includes('DATA_SHARING'))
  }, [consentRequired])

  const requireTos = consentRequired.includes('TOS_PRIVACY')
  const requireDataShare = consentRequired.includes('DATA_SHARING')  
  const canContinue = ((!requireTos || acceptedTos) &&
       (!requireDataShare || acceptedDataShare))

  const handleAccept = () => {
    if(requireTos) {
        dispatch(userActions.logConsent('TOS_PRIVACY'))
    }
    if(requireDataShare) {
        dispatch(userActions.logConsent('DATA_SHARING'))
    }
  }

  if(isLoading) {
      return <Loading />
  }
  
  return (
    <Container>
      <Row>
        <Col>
          <h1>Consent Statement</h1>
          <p>
            Welcome to the Job Passion Type Indicator (JPTI) assessment. If you have purchased
            Access to the assessment for your personal development your results will only be
            available to others when you disclose them directly or by clicking “SHARE”. If your
            access to the assessment was purchased for you by your company, career coach,
            school, advisor, or individual organization (“third party”) Careerz Group will share your
            results with both you and the third party to facilitate development and education. All
            information will be stored on Careerz Group servers in the United States of America.
            The Job Passion Type Indicator (JPTI) is a professional self-assessment tool designed
            to help individuals and organizations better understand intrinsic work-related
            preferences.
          </p>
          <p>
            I am aware of my rights regarding my Personal information (e.g., access, rectification or
            erasure, restriction of processing, data portability), about which I have read and
            understood in Careerz Group's
            <AnchorPopup prompt="Privacy Policy" link="https://careerzgroup.com/privacy/" trackingPage="privacy_policy"/>
            and
            <AnchorPopup prompt="JPTI Assessment Terms and Disclaimer" link="https://careerzgroup.com/jpti-assessment-terms-and-disclaimer/" trackingPage="terms_and_conditions" />.
          </p>
          {error && <p className="text-danger">Error: {error.message}</p>}
          <hr />
          {requireTos && <p> <input type="checkbox" checked={acceptedTos} onChange={e => setAcceptedTos(e.target.checked)} /> I consent with the statement above.</p>}
          {requireDataShare && <p><input type="checkbox" checked={acceptedDataShare} onChange={e => setAcceptedDataShare(e.target.checked)} /> I wish to share my results</p>}
        </Col>
      </Row>
      <Row>
        <Col className="text-left">
          <button className="btn btn-primary" disabled={!canContinue} onClick={handleAccept}>Continue to Assessment</button>
        </Col>
      </Row>
    </Container>
  )
}

const AnchorPopup = ({prompt, link, trackingPage}) => {
    const toggle = () => {

        if(trackingPage) {
            //going to display
            ReactGA.pageview(trackingPage)
        }

        window.open(link, '_blank')
    }

    return (<span> <a onClick={toggle} style={{cursor: "pointer", color: "blue", textDecoration: "underline"}}>{prompt}</a> </span>)
}
